// react
import React, { useState, useEffect } from 'react';

// third-party
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

// application
import Indicator from './Indicator';
import { Person20Svg } from '../../svg';
import { resetAuth, updateAction } from '../../store/auth/authActions';

export default function IndicatorAccount() {
  const [userData, setUserData] = useState(() => {
    try {
      const cached = localStorage.getItem('user_profile_data');
      return cached ? JSON.parse(cached) : false;
    } catch {
      return false;
    }
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    const getUser = async () => {
      try {
        const result = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_HOST_API}/auth/info`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const u = result.data?.response;
        setUserData(u);
        if (u) {
          localStorage.setItem('user_profile_data', JSON.stringify(u));
        }
        if (u?.user_code) {
          localStorage.setItem('user_code', u.user_code);
        }
        if (u?.id) {
          localStorage.setItem('user_id', u.id);
        }
      } catch (error) {
        console.log(error);
        dispatch(resetAuth());
      }
    };
    if (token) {
      getUser();
    } else {
      setUserData(false);
    }
  }, [token, dispatch]);

  const handleLogout = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    // 1. Reset Redux auth state
    dispatch(resetAuth());

    // 2. Clear local states
    setUserData(false);
    localStorage.removeItem('cart_total');
    localStorage.removeItem('user_code');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_profile_data');
    localStorage.removeItem('user_address_data');

    // 3. Dispatch cart count update to 0
    window.dispatchEvent(new CustomEvent('cart:count_updated', { detail: 0 }));
    dispatch(updateAction(Date.now()));

    // 4. Immediately redirect to login page in realtime without page reload
    history.push('/account/login');
  };

  const isPlaceholderAvatar =
    !userData?.user_image ||
    userData.user_image.includes('avatar-3.jpg') ||
    userData.user_image.includes('avatar-1.jpg') ||
    userData.user_image.includes('avatar-2.jpg') ||
    userData.user_image.includes('avatar-4.jpg') ||
    userData.user_image.includes('90x90');

  const loggedInDropdown = (
    <div className='account-menu account-menu--modern'>
      <Link to='/account/dashboard' className='account-menu__user-header'>
        <div className='account-menu__user-avatar-wrap'>
          {!isPlaceholderAvatar ? (
            <img
              src={userData.user_image}
              alt={userData?.name || 'User'}
              className='account-menu__user-avatar-img'
              onError={(e) => {
                e.target.style.display = 'none';
                if (e.target.nextElementSibling) {
                  e.target.nextElementSibling.style.display = 'flex';
                }
              }}
            />
          ) : null}
          <div
            className='account-menu__user-avatar-placeholder'
            style={{ display: !isPlaceholderAvatar ? 'none' : 'flex' }}
          >
            {userData?.name ? userData.name.trim().charAt(0).toUpperCase() : 'U'}
          </div>
          <span className='account-menu__user-status-dot' />
        </div>
        <div className='account-menu__user-meta'>
          <div className='account-menu__user-name' title={userData?.name || 'User Hokky'}>
            {userData?.name || 'User Hokky'}
          </div>
          {userData?.email && (
            <div className='account-menu__user-email' title={userData.email}>
              {userData.email}
            </div>
          )}
          <div className='account-menu__user-badge-wrap'>
            <span className='account-menu__user-badge'>
              <i className="fas fa-shield-alt mr-1" />
              Member Hokky
            </span>
          </div>
        </div>
      </Link>

      <div className='account-menu__nav-body'>
        <Link to='/account/dashboard' className='account-menu__nav-item'>
          <div className='account-menu__nav-icon'>
            <i className="far fa-user" />
          </div>
          <span className='account-menu__nav-label'>Profil</span>
          <i className="fas fa-chevron-right account-menu__nav-arrow" />
        </Link>

        <Link to='/account/orders' className='account-menu__nav-item'>
          <div className='account-menu__nav-icon'>
            <i className="fas fa-shopping-bag" />
          </div>
          <span className='account-menu__nav-label'>Pesanan Produk</span>
          <i className="fas fa-chevron-right account-menu__nav-arrow" />
        </Link>

        <Link to='/account/addresses' className='account-menu__nav-item'>
          <div className='account-menu__nav-icon'>
            <i className="fas fa-map-marker-alt" />
          </div>
          <span className='account-menu__nav-label'>Alamat Pengiriman</span>
          <i className="fas fa-chevron-right account-menu__nav-arrow" />
        </Link>

        <Link to='/account/password' className='account-menu__nav-item'>
          <div className='account-menu__nav-icon'>
            <i className="fas fa-key" />
          </div>
          <span className='account-menu__nav-label'>Password</span>
          <i className="fas fa-chevron-right account-menu__nav-arrow" />
        </Link>
      </div>

      <div className='account-menu__footer'>
        <button
          type='button'
          onClick={handleLogout}
          className='account-menu__logout-btn'
        >
          <div className='account-menu__logout-icon'>
            <i className="fas fa-sign-out-alt" />
          </div>
          <span className='account-menu__logout-label'>Keluar Akun</span>
        </button>
      </div>
    </div>
  );

  return (
    <Indicator
      className="indicator--account"
      url={token ? '/account/dashboard' : '/account/login'}
      dropdown={token ? loggedInDropdown : null}
      icon={<Person20Svg />}
    />
  );
}
